import { render, staticRenderFns } from "./EditVisite.vue?vue&type=template&id=20b6cead&"
import script from "./EditVisite.vue?vue&type=script&lang=js&"
export * from "./EditVisite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports